module.exports = __webpack_public_path__ + "img/tail-mb.e750d053.svg";